module.exports = __webpack_public_path__ + "img/0003.fa5121f6.png";